import React, { createContext, ReactNode, useContext, useState } from 'react';

interface RefreshContextValue {
  refreshToggle: boolean;
  triggerRefresh: () => void;
}

const RefreshContext = createContext<RefreshContextValue | undefined>(undefined);

type RefreshProviderProps = {
  children: ReactNode;
};

const RefreshProvider: React.FC<RefreshProviderProps> = ({ children }) => {
  const [refreshToggle, setRefreshToggle] = useState(false);

  const triggerRefresh = () => {
    setRefreshToggle((prev) => !prev);
  };

  return (
    <RefreshContext.Provider value={{ refreshToggle, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = (): RefreshContextValue => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }
  return context;
};

export default RefreshProvider;
